//import { Action, AsyncAction } from '../types/types';
import {
	GetBroadcastServer,
	StartBroadcast,
	StopBroadcast,
} from '../../../connection/broadcasting';
import { BroadcastStats, BROADCAST_STATES } from '../../reducers/admin/broadcasting';

export interface Action {
	type: string;
	payload: any;
	remote?: boolean;
	id?: number;
}

export interface AsyncAction {
	type: string;
	promise: Promise<any>
}

export interface CustomRtmpData {
	useCustomEndpoint: boolean;
	endpoint: {
		name: string,
		url: string,
		stream_key: string
	}
}

export const GET_BROADCAST_SERVER = "GET_BROADCAST_SERVER";
export function getBroadcastServer(token: string, session_uuid: string): AsyncAction {
	return {
		type: GET_BROADCAST_SERVER,
		promise: GetBroadcastServer(token, session_uuid)
	};
}


export const START_BROADCAST = "START_BROADCAST";
export function startBroadcast(token: string, session_uuid: string, resolution: string): AsyncAction {
	return {
		type: START_BROADCAST,
		promise: StartBroadcast(token, session_uuid, resolution)
	};
}

export const STOP_BROADCAST = "STOP_BROADCAST";
export function stopBroadcast(token: string, session_uuid: string): AsyncAction {
	return {
		type: STOP_BROADCAST,
		promise: StopBroadcast(token, session_uuid)
	};
}

export const SET_BROADCAST_STATE = "SET_BROADCAST_STATE";
export function setBroadcastState(state: BROADCAST_STATES): Action {
	return {
		type: SET_BROADCAST_STATE,
		payload: state
	};
}

export const SET_BROADCAST_STATS = "SET_BROADCAST_STATS";
export function setBroadcastStats(stats: BroadcastStats): Action {
	return {
		type: SET_BROADCAST_STATS,
		payload: stats
	};
}

export const SET_STREAM_STATE = "SET_STREAM_STATE";
export function setStreamState(status: number): Action {
	return {
		type: SET_STREAM_STATE,
		payload: status
	};
}

export const SET_GO_LIVE_BUTTON_CLICKED = "SET_GO_LIVE_BUTTON_CLICKED";
export function setGoLiveButtonClicked(goLiveButtonClicked: boolean): Action {
	return {
		type: SET_GO_LIVE_BUTTON_CLICKED,
		payload: goLiveButtonClicked
	};
}
